import type { ReactNode } from 'react';
import { useRef, useState } from 'react';
import { styled } from 'styled-components';
import { useViewportWidth } from '@frontend/utils/hooks/useViewportWidth';
import { Breakpoints } from '../../../common/enums/breakpoints';

export function BackgroundImageTemplate({ children }: { children: ReactNode }) {
    const [valid, setValid] = useState(true);
    const { width } = useViewportWidth();

    const ImageComponent = ({ src }: { src: string }) => {
        const image = useRef<HTMLImageElement>(null);

        const checkValid = () => {
            if (!image.current?.complete || image.current.naturalWidth < 1 || image.current.naturalHeight < 1) {
                setValid(false);
            }
        };

        if (valid) {
            return (
                <StyledImage
                    onError={() => setValid(false)}
                    onLoad={checkValid}
                    ref={image}
                    src={src}
                />
            );
        }

        return null;
    };

    return (
        <StyledOuterContainer>
            <StyledContainer $isValid={valid}>{children}</StyledContainer>
            {width > Breakpoints.small ? <ImageComponent src="/assets/images/background.jpg" /> : null}
        </StyledOuterContainer>
    );
}

const StyledOuterContainer = styled.div`
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    height: 100%;
    overflow-x: hidden;
    position: relative;
    background-color: ${({ theme }) => theme.colors.white};
`;

const StyledContainer = styled.div<{ $isValid: boolean }>`
    margin-bottom: 0;
    padding: 32px;
    border-radius: 0;
    border: 0;
    height: auto;
    min-height: 100%;
    z-index: 1;
    background-color: ${({ theme }) => theme.colors.white};

    ${({ theme }) => theme.mediaQueries.small} {
        max-width: 560px;
        padding: 100px 0 100px 100px;
        position: relative;

        ${({ $isValid, theme }) =>
            $isValid
                ? `&:after{
            content: '';
            height: 100%;
            width: 100%;
            right: calc(-100% + 1px);
            background: url('/assets/images/beeldmerk_WhiteA_HR.png') no-repeat;
            background-size: 100% 100%;
            display: block;
            position: absolute;
            top:0;
            bottom:0;
            z-index: 1;

        }`
                : `&:after{
            backgroundColor: ${theme.colors.white};
        }
        `}
    }
`;

const StyledImage = styled.img`
    width: 100vw;
    position: absolute;
    inset: 0;
    height: 100%;
    object-fit: cover;
`;
